import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const query = graphql(`
  query SolarElectricalPrices(
    $ids: [ID!]!
    $pagination: PaginationInput!
    $quantity: Int!
  ) {
    appliances(ids: $ids, pagination: $pagination) {
      items {
        id
        items {
          id
        }
        totalPrice(quantity: $quantity) {
          value
          currency {
            code
            exponent
          }
        }
      }
      totalCount
    }
  }
`);
export const useSolarElectricalPrices = (
  quantities: Map<string, number> | null
) => {
  const selected = [...(quantities ?? new Map<string, number>())].sort(
    ([a], [b]) => a.localeCompare(b)
  );
  return useQuery({
    queryKey: ['solar-electrical-prices', selected],
    enabled: selected.length > 0,
    queryFn: async () => {
      const groups = Map.groupBy(selected, ([, quantity]) => quantity);
      const pages = await Promise.all(
        [...groups].flatMap(([quantity, items]) =>
          Array.from({ length: Math.ceil(items.length / 100) }, (_, index) =>
            gqlClient
              .request(query, {
                ids: items
                  .slice(index * 100, index * 100 + 100)
                  .map(([id]) => id),
                quantity,
                pagination: { limit: 100, offset: 0 },
              })
              .then((page) =>
                page.appliances.items.map((item) => ({ ...item, quantity }))
              )
          )
        )
      );
      return pages.flat();
    },
  });
};
